import styled from '@emotion/styled';

const Section = styled.section`
    margin-bottom: ${(props) => props.theme.spaces.navbarHeight};
    width: 100%;
`;

export default Section;
